import { render, staticRenderFns } from "./modalEditarCuentaMercadoPago.vue?vue&type=template&id=12b06f63&"
import script from "./modalEditarCuentaMercadoPago.vue?vue&type=script&lang=js&"
export * from "./modalEditarCuentaMercadoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports